module.exports = __webpack_public_path__ + "img/empty_course.4315f5a7.png";